import React from 'react';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Hooks
import { useUpdateAiReports } from 'Shared/utils/hooks/use-update-ai-reports';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody, WpPageTitle } from 'Wpds/components/page-layout';
import { WpBadge } from 'Wpds/components/badge';
import { WpBreadcrumbs, WpBreadcrumbItem } from 'Wpds/components/breadcrumbs';
import UpdateAiSelectTemplate from './UpdateAiTemplates/UpdateAiSelectTemplate';
import ReportsList from './ReportsList/ReportsList';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

// Styles
import './UpdateAiPage.scss';

const UpdateAiPage = () => {
  const { draftReports, notDraftReports, isFetching } = useUpdateAiReports();

  const reports = [...draftReports, ...notDraftReports];
  const showEmptyState = !isFetching && reports.length === 0;

  const baseClassName = 'UpdateAiPage';
  return (
    <WpPageLayout className={baseClassName} width="container">
      <WpPageHeader>
        <WpPageTitle
          title="UpdateAI"
          breadcrumbs={
            <WpBreadcrumbs>
              <WpBreadcrumbItem label="AI Toolkit" to={PageUrlsConstants.AI_TOOLKIT_PAGE} />
              <WpBreadcrumbItem label="UpdateAI" />
            </WpBreadcrumbs>
          }
          postfix={
            <WpBadge color="purple" variant="bold">
              Beta
            </WpBadge>
          }
        />
      </WpPageHeader>
      <div className={`${baseClassName}__templates`}>
        <div className={`${baseClassName}__templates__inner`}>
          <p className={`${baseClassName}__templates__title`}>Create new update</p>
          <UpdateAiSelectTemplate />
        </div>
      </div>
      <WpPageBody>
        <p>Recent reports</p>
        <ReportsList reports={reports} isFetching={isFetching} />
        {showEmptyState && (
          <EmptyStateContainer
            title="No recent reports"
            subTitle="Select a template above to get started with a new update"
            inContainer
            titleTag="h5"
          />
        )}
      </WpPageBody>
    </WpPageLayout>
  );
};

export default UpdateAiPage;
